const news = {
  newsItems: [
    {
      date: '28-01-2026:',
      title:
        '11 pups geboren nestjes Shiva v/d Meulenbarg X Max van de Lobohoeve!',
      subtitle:`Op <b>28 januari 2026</b> zijn er 11 pups geboren 7 teefjes en 4 reutjes. De pups zijn veel belovend <b>Intresse? Neem dan contact met ons op.</b>`,
      link: '/pups',
    },
    {
      date: '02-12-2025:',
      title:
        'Eind Januari 2026 Nestje Shiva v/d Meulenbarg X Max van de Lobohoeve',
      subtitle:`Rond <b>31 januari 2026</b> verwachten wij opnieuw een fantastisch nest pups uit de combinatie: <b>Shiva v/d Meulenbarg X Max van de Lobohoeve</b>`,
      link: '/pups',
    },
    {
      date: '05-09-2025:',
      title:
        'Planning Voorjaar 2026: Nestje Shiva v/d Meulenbarg X Max van de Lobohoeve',
      subtitle:
        'In het voorjaar van 2026 staat een nestje van Shiva v/d Meulenbarg en Max van de Lobohoeve gepland. Deze veelbelovende combinatie heeft zich al eerder bewezen. We houden je op de hoogte van de ontwikkelingen.',
      link: '/pups',
    },
    {
      date: '20-08-2025:',
      title:
        'Quincy v/d Meulenbarg X Germali\'s Nero 1 teefje geboren!',
      subtitle:
        'Het laatste nestje van Quincy v/d Meulenbarg X Germali\'s Nero is geboren! Er is 1 teefje geboren deze is niet meer beschikbaar.',
      link: '/pups',
    },
    {
      date: '20-06-2025:',
      title:
        'Half augustus 2025 laatste nestje Quincy v/d Meulenbarg X Germali\'s Nero!',
      subtitle:
        'Rond 16 augustus 2025 verwachten we het laatste nestje van Quincy v/d Meulenbarg X Germali\'s Nero. Velen bewijzen zich, pups zijn perfect voor de africhting of als huishond!',
      link: '/pups',
    },
    {
      date: '27-06-2025:',
      title:
        'Voorjaar 2026 planning nestje Shiva v/d Meulenbarg',
      subtitle:
        'We hebben voor het voorjaar van 2026 een nestje van Shiva v/d Meulenbarg op de planning. Zodra we meer info hebben zullen we dit delen.',
      link: '/pups',
    },
    {
      date: '01-08-2024:',
      title:
        'Alle 19 pups hebben een baasje gevonden!',
      subtitle:
        'Alle pups van Shiva v/d Meulenbarg x Max van de Lobohoeve & Quincy v/d Meulenbarg X Germali\'s Nero hebben een baasje gevonden. We kijken uit naar de toekomst met hopelijk nog meer mooie pups!',
      link: '/pups',
    },
    {
      date: '13-07-2024:',
      title:
        'Er zijn nog 3 pups beschikbaar, 2 teefjes en 1 reutje!',
      subtitle:
        'Van Shiva v/d Meulenbarg x Max van de Lobohoeve is er nog <b>1 reutje</b> beschikbaar en van Quincy v/d Meulenbarg X Germali\'s Nero zijn er nog <b>2 teefjes</b> beschikbaar! Neem contact op voor meer informatie!',
      link: '/pups',
    },
  ],
  header: 'Het laatste nieuws',
};

export default news;
